var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPlaceholderWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "65px",
    height: "71px",
    viewBox: "0 0 65 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-person-4851855") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-person-4851855",
    transform: "translate(0.479000, 0.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.00014,36.6084369 C41.4479258,36.6084369 49.1329949,26.5814808 49.1329949,17.1342552 C49.1329949,7.68758971 41.4482058,3.97993481e-15 32.00014,3.97993481e-15 C22.5520742,3.97993481e-15 14.8658848,7.68744968 14.8658848,17.1342552 C14.8675259,26.5803606 22.5523543,36.6084369 32.00014,36.6084369 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.862034,36.7834763 C41.5385262,39.315526 37.3927534,40.8219849 32.9019429,40.8219849 L31.097917,40.8219849 C26.6059863,40.8219849 22.4592333,39.3149659 19.1367058,36.7834763 C8.28594434,38.537651 -3.97993481e-15,47.9432872 -3.97993481e-15,59.2879398 C-3.97993481e-15,65.5204621 14.3266235,70.5747593 32,70.5747593 C49.6733765,70.5747593 64,65.5204621 64,59.2879398 C64,47.9425871 55.7129354,38.5366708 44.8618939,36.7834763 L44.862034,36.7834763 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlaceholderWhite);
export default __webpack_public_path__ + "static/media/user_placeholder_white.72a572952c3bc53574181c32666928df.svg";
export { ForwardRef as ReactComponent };